import queryString from 'query-string'
import StandaloneAdapter from './standaloneAdapter'
import FakeAdapter from './fakeAdapter'
import JiraConnectAdapter from './jiraConnectAdapter'
import JiraServerAdapter from './jiraServerAdapter'

export const getHostAdapter = () => {
  const parsed = queryString.parse(window.location.search)
  if (typeof parsed.mode === 'undefined') {
    return new StandaloneAdapter()
  }

  if (typeof parsed.host === 'string' && parsed.host === 'jira_server') {
    return new JiraServerAdapter()
  }

  if (typeof AP === 'undefined') {
    return new FakeAdapter()
  }

  return new JiraConnectAdapter()
}
